import { render, staticRenderFns } from "./AddOrderTask.vue?vue&type=template&id=3e04b1b0"
import script from "./AddOrderTask.vue?vue&type=script&lang=js"
export * from "./AddOrderTask.vue?vue&type=script&lang=js"
import style0 from "./AddOrderTask.vue?vue&type=style&index=0&id=3e04b1b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports